import Datepicker from "react-tailwindcss-datepicker";

export const DatePicker = ({ setFilterDate, filterDate }) => {
  const handleValueChange = (newValue) => {
    setFilterDate(newValue);
  };

  return (
    <Datepicker
      value={filterDate}
      showShortcuts={true}
      onChange={handleValueChange}
      maxDate={new Date()}
      disabledDates={[new Date()]}
    />
  );
};
